import React, { useState, useEffect, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import {
  Ballot,
  Close,
  Edit,
  LocalShipping,
  CheckCircle,
  HourglassEmpty,
  Cancel,
  RadioButtonChecked,
  FolderShared,
  Add,
  CancelRounded,
  Map,
  CallSplit,
  Restore
} from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import Badge from 'components/Badge/Badge';
import { Box, Checkbox, Tooltip } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { WithApp } from 'contexts/appContext';
import { useNavigate } from 'react-router-dom';

import { useModal } from 'hooks/useModal.js';
import ESDModal from './ModalEditSheetDistribution/ESDModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { currency } from 'hooks/Pipe.js';
import { nDecimal } from 'hooks/Pipe.js';
import ModalFull from 'components/Tvendo/Common/ModalFull.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import styleSweet from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import OpenZone from './OpenZone';
import { useAuth } from 'hooks/useAuth';
import { wsGetAll, wsPost, wsUrl, wsFindBy } from 'services/WService.js';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import AnnuledSapModal from './AnnuledSapModal';
import ListConfig from './ConfigurationModal.jsx';
import ErrorOrdersModal from './ErrorOrdersModal';
import ConfirmModal from './ConfirmModal';

const styles = {
  ...styleSweet,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  colorInfo: {
    color: '#00acc1'
  },
  colorDefault: {
    color: '#c6c6c6'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 200 },
  { Header: 'Acciones', accessor: 'action', excelEnabled: false, width: 200 },
  { Header: 'Estado', accessor: 'state', excelEnabled: false, width: 100 },
  { Header: 'Confirm', accessor: 'confirmed', excelEnabled: true, width: 95 },
  { Header: 'HR', accessor: 'id', width: 70 },
  { Header: 'Ref', accessor: 'reference', width: 80 },
  { Header: 'Avance', accessor: 'advance', width: 80 },
  { Header: 'Zona', accessor: 'zone', width: 80 },
  { Header: 'Vehiculo', accessor: 'codeVehicle', width: 90 },
  { Header: 'Jefe reparto', accessor: 'distManager' },
  { Header: 'Enc. mercadería', accessor: 'distInventoryManager' },
  { Header: 'Programación', accessor: 'scheduledDate', width: 130 },
  { Header: 'Despacho', accessor: 'dispatchDate', width: 120, align: 'right' },
  { Header: 'Monto', accessor: 'amount', width: 100, align: 'center' },
  { Header: 'Cli.', accessor: 'customers', width: 60, align: 'right' },
  { Header: 'Peso', accessor: 'weight', width: 60, align: 'right' },
  { Header: 'Vol.', accessor: 'volume', width: 60, align: 'right' },
  { Header: 'Nombre almacén', accessor: 'warehouse', width: 160 },
  { Header: 'Ult. Proceso', accessor: 'processDate', width: 130 },
  { Header: 'Mensaje error', accessor: 'errorMessage', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

const listStates = [
  { id: 'N', name: 'Creado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'G', name: 'Generado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'A', name: 'Anulado', color: 'danger', icon: <Cancel /> },
  { id: 'F', name: 'Facturado', color: 'warning', icon: <HourglassEmpty /> },
  { id: 'W', name: 'En Reparto', color: 'success', icon: <CheckCircle /> },
  {
    id: '1',
    name: 'Liq. de mercaderia',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '2',
    name: 'Liq. de mercaderia +',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '3',
    name: 'Liq. de documento',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '4',
    name: 'Liq. de documento +',
    color: 'success',
    icon: <CheckCircle />
  },
  { id: 'L', name: 'Liq. HR', color: 'success', icon: <CheckCircle /> },
  { id: '5', name: 'Cerrado', color: 'primary', icon: <Cancel /> }
];

export default WithApp(function Programming(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  let navigate = useNavigate();
  const { hasPermission } = useAuth();
  const [dataLoading, setDataLoading] = useState(false);

  const [openZones, setOpenZones] = useState([]);
  const [programmings, setProgrammings] = useState([]);
  const [zoneSatus, setZoneStatus] = useState(false);
  const [valueSearch, setValueSearch] = useState({});
  const [confirmModal, setConfirmModal] = useModal();
  const [configModal, setConfigModal] = useModal();


  const confirmableSheets = useMemo(() => {
    return programmings
      .filter((sheet) => sheet.confirmed !== 'Y' && sheet.state !== 'A')
      .map((sheet) => sheet.id);
  }, [programmings]);
  const [selectedSheets, setSelectedSheets] = useState([]);

  function toggleConfirmedCheck() {
    const checked = confirmableSheets.length > 0 && selectedSheets.length === confirmableSheets.length;
    const indeterminate = confirmableSheets.length > 0 && selectedSheets.length < confirmableSheets.length && selectedSheets.length > 0;
    if (checked || indeterminate) {
      setSelectedSheets([]);
    } else {
      setSelectedSheets(confirmableSheets);
    }
  }

  function confirmSelected() {
    const sheets = programmings.filter(prog => selectedSheets.includes(prog.id));
    if (sheets.length > 0) {
      setConfirmModal({ sheets });
    }
  }

  function configurationList() {
    if (valueSearch.base_zone_id === null || valueSearch.base_zone_id === undefined) {
      showNotify('Seleccionar una zona en el filtro para mostrar información', 'info');
      return;
    }
    setConfigModal({ base_zone_id: ( valueSearch?.base_zone_id ) });
  }


  // Modal
  const [urlPDF, setUrlPDF] = useState({ hr: '', hc: '' });
  const [showHR, setShowHR] = useState(false);
  const [showHC, setShowHC] = useState(false);
  const [model, setOpenProg] = useModal();
  const [errorModel, setErrorOrderOpen] = useModal();

  const [annularSapSheet, setAnnularSapSheet] = useState();

  async function listOpenZones() {
    setDataLoading(true);
    let response = await wsGetAll('prog/zone-open');
    setDataLoading(false);
    if (response.success) {
      setOpenZones(response.data);
      setZoneStatus(response.data.map((item) => (item.open !== null ? true : false)));
    }
  }

  //#region programacion
  async function listProgramming() {
    setDataLoading(true);
    let response = await wsFindBy('prog/sheet-distribution', { ...valueSearch, with_count: 'Y' });
    setDataLoading(false);
    if (response.success) setProgrammings(response.data);
  }

  async function getUrlHC(value) {
    setDataLoading(true);
    let urlPdfHC = wsUrl('prog/sheet-distribution/' + value.id + '/sheet-load');
    setUrlPDF({ hc: urlPdfHC });
    setShowHC(true);
    setDataLoading(false);
  }

  function getUrlHR(value) {
    setDataLoading(true);
    let urlPdfHR = wsUrl('prog/sheet-distribution/' + value.id + '/pdf');
    setUrlPDF({ hr: urlPdfHR });
    setShowHR(true);
    setDataLoading(false);
  }

  //#endregion fin de programacion

  //#region  sweetAlert
  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(id) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de facturar?"
        onConfirm={() => {
          facturar(id);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  const [alert2, setAlert2] = useState(null);
  const hideAlert2 = () => {
    setAlert2(null);
  };
  function confirmAnnule(id) {
    setAlert2(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de anular?"
        onConfirm={() => {
          annular(id);
          hideAlert2();
        }}
        onCancel={() => hideAlert2()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  function confirmAnnuledSap(id) {
    setAlert2(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de anular hoja del sap?"
        onConfirm={() => {
          annularSap(id);
          hideAlert2();
        }}
        onCancel={() => hideAlert2()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />,
    );
  }

  //#endregion

  async function facturar(idHR) {
    setDataLoading(true);
    let response = await wsPost(`prog/sheet-distribution/${idHR}/facturar`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      listProgramming();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function annular(idHR) {
    setDataLoading(true);
    let response = await wsPost(`prog/sheet-distribution/${idHR}/annular`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      listProgramming();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function annularSap(idHR) {
    setDataLoading(true);
    let response = await wsPost(`prog/sheet-distribution/${idHR}/annular-sap`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      listProgramming();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (hasPermission(ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE)) listOpenZones();
  }, []);

  useEffect(() => {
    if (Object.keys(valueSearch).length > 0) listProgramming(valueSearch);
  }, [valueSearch]);

  return (
    <>
      <Toasty action={notify} time={12000} />
      <AnnuledSapModal
        onProcess={confirmAnnuledSap}
        sheetDistribution={annularSapSheet}
        setSheetDistribution={setAnnularSapSheet}
        showNotify={showNotify}
        reload={listProgramming}
        setProgrammings={setProgrammings}
      />

      <ListConfig
        setOpen={setConfigModal}
        model={configModal}
        showNotify={showNotify}
        reload={listProgramming}
      />

      <ConfirmModal
        model={confirmModal}
        setOpen={setConfirmModal}
        showNotify={showNotify}
        reload={listProgramming}
      />
      {alert}
      {alert2}
      <GridContainer>
        <ModalFull title="Hoja reparto" open={showHR} setOpen={setShowHR} iframe>
          <iframe src={showHR ? urlPDF.hr : undefined} width="100%" height="100%">
            No se pudo cargar el contenido.
          </iframe>
        </ModalFull>

        <ModalFull title="Hoja carga" open={showHC} setOpen={setShowHC} iframe>
          <iframe src={showHC ? urlPDF.hc : undefined} width="100%" height="100%">
            No se pudo cargar el contenido.
          </iframe>
        </ModalFull>

        <ESDModal
          model={model}
          setOpen={setOpenProg}
          showNotify={showNotify}
          reload={listProgramming}
        />

        <ErrorOrdersModal
          model={errorModel}
          setOpen={setErrorOrderOpen}
          showNotify={showNotify}
          reload={listProgramming}
        />

        <AllowedGuard permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE}>
          <GridItem xs={12}>
            <OpenZone zones={openZones} showNotify={showNotify} reload={listOpenZones} />
          </GridItem>
        </AllowedGuard>

        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE}
                component={
                  <CardIcon color="primary">
                    <FolderShared style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <span
                  onClick={() => {
                    if (zoneSatus === false) return;
                    if (!zoneSatus?.includes(true)) {
                      showNotify('Para programar debe exister una zona con apertura', 'info');
                      return;
                    }
                    return navigate('0');
                  }}
                >
                  <CardIcon pointer="true" color="success">
                    <Add style={{ color: 'white' }} />
                  </CardIcon>
                </span>
                <CardIcon
                  pointer="true"
                  color="success"
                  onClick={() => {
                    if (zoneSatus === false) return;
                    if (!zoneSatus?.includes(true)) {
                      showNotify('Para programar debe exister una zona con apertura', 'info');
                      return;
                    }
                    return navigate('mapa');
                  }}
                >
                  <Map style={{ color: 'white' }} />
                </CardIcon>
              </AllowedGuard>
              <Box display="flex">
                <Box flex={1}>
                  <h4 className={classes.cardIconTitle}>Listado de programaciones{dataLoading && <LoadingSpinner />}</h4>
                </Box>

                <Box>
                  <Checkbox
                    margin="normal"
                    checked={confirmableSheets.length > 0 && selectedSheets.length === confirmableSheets.length}
                    indeterminate={confirmableSheets.length > 0 && selectedSheets.length < confirmableSheets.length && selectedSheets.length > 0}
                    disabled={confirmableSheets.length === 0}
                    onChange={toggleConfirmedCheck}
                  />
                  <Button color="success" disabled={selectedSheets.length === 0} onClick={confirmSelected}>
                    Confirmar seleccionados{selectedSheets.length > 0 && (` (${selectedSheets.length})`)}
                  </Button>
                </Box>

              </Box>
            </CardHeader>
            <CardBody>
              <FilterCustom getFilter={setValueSearch} dateRangeProg diffRange={1} zone />
              <Box>
                <Button color="info" onClick={configurationList} >
                  Programación sugerida
                </Button>
              </Box>

              <ReactTable
                excelName="Programaciones"
                defaultWidth={2500}
                columns={columns}
                formatDate="DD-MM-YYYY"
                data={programmings.map((prog, i) => {
                  let color = 'danger';
                  let state = '-';
                  let hasError = false;
                  let stateIndex = listStates.findIndex((obj) => obj.id == prog.state);
                  if (stateIndex !== -1) {
                    color = listStates[stateIndex].color;
                    state = listStates[stateIndex].name;
                  }
                  if (prog.state === 'A' && prog.sapAnnuled === 'P') {
                    color = 'warning';
                    state = 'Anulando...';
                  }
                  if (prog.state === 'F' && 'error_orders' in prog) {
                    hasError = true;
                    color = 'danger';
                    state = 'Error!';
                  }

                  return {
                    num: (
                      <div className="actions-left">
                        <Checkbox
                          margin="normal"
                          checked={selectedSheets.includes(prog.id)}
                          disabled={!confirmableSheets.includes(prog.id)}
                          onChange={() =>
                            setSelectedSheets(sheets => {
                              let newSheets = [...sheets];
                              if (newSheets.includes(prog.id)) {
                                let index = newSheets.findIndex(sheetId => sheetId === prog.id);
                                newSheets.splice(index, 1);
                              } else {
                                newSheets.push(prog.id);
                              }
                              return newSheets;
                            })
                          }
                        />
                        <Tooltip title="Visualizar Hoja de carga">
                          <Button
                            disabled={!(listStates.findIndex((obj) => obj.id == prog.state) >= 3)}
                            justIcon
                            round
                            simple
                            className={
                              listStates.findIndex((obj) => obj.id == prog.state) >= 3
                                ? classes.colorInfo
                                : classes.colorDefault
                            }
                            onClick={() => {
                              getUrlHC(prog);
                            }}
                          >
                            <LocalShipping />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Visualizar Hoja de reparto">
                          <Button
                            disabled={!(listStates.findIndex((obj) => obj.id == prog.state) >= 4)}
                            justIcon
                            round
                            simple
                            className={
                              listStates.findIndex((obj) => obj.id == prog.state) >= 4
                                ? classes.colorInfo
                                : classes.colorDefault
                            }
                            onClick={() => {
                              getUrlHR(prog);
                            }}
                          >
                            <Ballot />
                          </Button>
                        </Tooltip>
                        <Tooltip
                          title={
                            prog.state == 'N' || prog.state == 'G'
                              ? 'Facturar documento'
                              : prog.state == 'F'
                                ? 'por pasar a Reparto'
                                : prog.state == '5'
                                  ? 'Cerrado'
                                  : prog.state == 'A' && prog.sapAnnuled === 'P'
                                    ? 'Anulando...'
                                    : (prog.state == 'A' && prog.sapAnnuled === null) ||
                                      prog.sapAnnuled === 'Y'
                                      ? 'Anulado'
                                      : 'En reparto'
                          }
                        >
                          <Button
                            justIcon
                            round
                            simple
                            color={
                              prog.state == 'G'
                                ? 'warning'
                                : prog.state == 'A'
                                  ? 'danger'
                                  : prog.state == '5'
                                    ? 'primary'
                                    : prog.state == 'F'
                                      ? 'warning'
                                      : 'success'
                            }
                            className="like"
                            onClick={() => {
                              if (prog.state == 'G' || prog.state == 'N') {
                                confirm(prog.id);
                              }
                            }}
                          >
                            {listStates.findIndex((obj) => obj.id == prog.state) >= 0
                              ? listStates[listStates.findIndex((obj) => obj.id == prog.state)].icon
                              : '- | ' + prog.state}
                          </Button>
                        </Tooltip>
                        {i + 1}
                      </div>
                    ),
                    state: (
                      <div>
                        <Badge color={color}>{state}</Badge>
                        {hasError && (
                          <Button
                            size="sm"
                            color="danger"
                            justIcon
                            simple
                            round
                            onClick={() => setErrorOrderOpen(prog)}
                          >
                            <Restore />
                          </Button>
                        )}
                      </div>
                    ),
                    // confirmed: prog.confirmed === 'Y' ? 'Si' : 'No',
                    confirmed: prog.hoja_reparto?.length > 0 ? (
                      <Badge color='info'>{prog.confirmed === 'Y' ? 'Si' : 'No'}</Badge>
                    ) : prog.confirmed === 'Y' ? 'Si' : 'No',
                    action: (
                      <div className="actions-right">
                        <AllowedGuard
                          permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_UPDATE}
                        >
                          <Button
                            disabled={
                              prog.state === 'G' || prog.state === 'F' || prog.state === 'W'
                                ? false
                                : true
                            }
                            justIcon
                            round
                            simple
                            color="info"
                            onClick={() => setOpenProg(prog)}
                          >
                            <Edit />
                          </Button>
                        </AllowedGuard>

                        <AllowedGuard
                          permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_STORE}
                        >
                          <Button
                            disabled={
                              prog.confirmed === 'Y' ? true : !['G', 'F', 'W'].includes(prog.state)
                            }
                            justIcon
                            round
                            simple
                            color="success"
                            onClick={() => {
                              navigate(`agregar/${prog.id}`);
                            }}
                          >
                            <Add />
                          </Button>
                        </AllowedGuard>

                        <AllowedGuard
                          permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_DELETED}
                        >
                          <Button
                            disabled={prog.state === 'G' ? false : true}
                            justIcon
                            round
                            simple
                            color="danger"
                            className="like"
                            onClick={() => {
                              confirmAnnule(prog.id);
                            }}
                          >
                            <Close />
                          </Button>
                        </AllowedGuard>

                        <AllowedGuard
                          permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_ANNULAR_SAP}
                        >
                          <Tooltip title={'Anular hoja sap'}>
                            <Button
                              // disabled={!['W', 'F'].includes(prog.state)}
                              justIcon
                              round
                              simple
                              color="danger"
                              className="like"
                              onClick={() => {
                                setAnnularSapSheet(prog);
                              }}
                            >
                              <CancelRounded />
                            </Button>
                          </Tooltip>
                        </AllowedGuard>
                        <AllowedGuard
                          permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_UPDATE}
                        >
                          <Tooltip title={'Dividir hoja'}>
                            <Button
                              justIcon
                              round
                              simple
                              color="warning"
                              className="like"
                              onClick={() => {
                                navigate(`dividir/${prog.id}`);
                              }}
                              disabled={!['N', 'G', 'F', 'W'].includes(prog.state)}
                            >
                              <CallSplit />
                            </Button>
                          </Tooltip>
                        </AllowedGuard>
                      </div>
                    ),
                    id: prog.id.toString(),
                    reference: prog.reference,
                    advance: (
                      <>
                        {prog.facturados} - {prog.orders}
                      </>
                    ),
                    zone: prog.base_zone_description,
                    codeVehicle: prog.prog_vehicle_code,
                    distManager: prog.manager_name,
                    distInventoryManager: prog.inventory_manager_name,
                    scheduledDate: prog.scheduled_date,
                    dispatchDate: prog.dispatch_date,
                    amount: currency(prog.amount),
                    customers: prog.customers,
                    weight: nDecimal(prog.weight),
                    volume: nDecimal(prog.volume),
                    warehouse: prog.logi_warehouse_name,
                    processDate: prog.last_process_date,
                    errorMessage: prog.error_message || '-',
                    actions: '',
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
});
